/** One event as the server accepts it (the server checks names against its own allow-list). */
export interface ActivityEvent {
  event_name: string;
  client_at: string;
  module_cd?: string;
  route_template?: string;
  action_cd?: string;
  outcome?: string;
  tab_id: string;
  duration_ms?: number;
  meta?: Record<string, string>;
}

/** What the browser reports about itself; none of it is trusted by the server. */
export interface ClientProfile {
  screen_width: number;
  screen_height: number;
  viewport_width: number;
  viewport_height: number;
  pixel_ratio: number;
  color_depth: number;
  orientation: string;
  prefers_dark_mode: boolean;
  display_mode: string;
  language: string;
  languages: string;
  timezone: string;
  timezone_offset_min: number;
  platform: string;
  cpu_cores: number;
  device_memory_gb: number;
  touch_points: number;
  online: boolean;
  connection_type: string;
  effective_type: string;
  downlink_mbps: number;
  rtt_ms: number;
  cookies_enabled: boolean;
  do_not_track: boolean;
  app_version: string;
  entry_route: string;
  referrer: string;
}

export interface ActivityBatch {
  profile?: ClientProfile;
  events: ActivityEvent[];
}

/** The `environment.activity` settings. */
export interface ActivityConfig {
  enabled: boolean;
  endpoint: string;
  heartbeatSeconds: number;
  flushSeconds: number;
  flushMaxEvents: number;
  maxQueue: number;
  maxMessageLength: number;
  /** The same browser error is reported once per this many seconds. */
  errorDedupeSeconds: number;
  /** Hard cap on browser errors reported per minute, so an error loop cannot flood the server. */
  errorMaxPerMinute: number;
  appVersion: string;
}

/** Event names the tracker sends; the server allow-list must contain each of them. */
export const ActivityEventName = {
  appOpened: 'app.opened',
  sessionStarted: 'session.started',
  sessionHeartbeat: 'session.heartbeat',
  sessionEnded: 'session.ended',
  sessionTabClosed: 'session.tab_closed',
  pageViewed: 'page.viewed',
  pageLeft: 'page.left',
  pageHidden: 'page.hidden',
  pageVisible: 'page.visible',
  actionClicked: 'action.clicked',
  navigationFailed: 'navigation.failed',
  frontendException: 'frontend.exception',
} as const;
